/* priceattack */

$(document).ready(function () {
	// make slides clickable if they have no text, or if link applied to entire slide
	$('.slide_has_no_text_but_link').on('click', function () {
		var link = $(this).data('slide-link');
		window.location.href = link;
		return false;
	});

	// hide collection tags in filter when there are more than settings defined amount
	$('.collection-sidebar__items').each(function () {
		//console.log($(this).find('li:gt(4)'));
		if ($(this).find('li:gt(4)').length && $(window).width() > 981) {
			$(this)
				.find('li:gt(4)')
				.hide()
				.end()
				.append(
					$(
						'<li class="collection-sidebar__item collection-sidebar__item--showmore">' +
							'Show more' +
							'</li>'
					).click(function () {
						if ($(this).hasClass('collection-sidebar__item--showmore')) {
							$(this).siblings(':hidden').show().end();
							$(this).removeClass('collection-sidebar__item--showmore');
							$(this).addClass('collection-sidebar__item--showless');
							$(this).html('Show less');
						} else if ($(this).hasClass('collection-sidebar__item--showless')) {
							$(this).parent().find('li:gt(4)').not($(this)).hide().end();
							$(this).addClass('collection-sidebar__item--showmore');
							$(this).removeClass('collection-sidebar__item--showless');
							$(this).html('Show more');
						}
					})
				);
		}
	});

	// Cart Message
	var cartMessage = {
		cartMessage: null,

		init: function () {
			this.cartMessage = $('.cart-message');

			if (this.cartMessage) {
				this.min = this.cartMessage.data('min');
				this.max = this.cartMessage.data('max');

				// Listen to cart change, this will trigger on page load and every time items in the cart are modified
				$(document.body).on('afterGetCart.ajaxCart', (event, cart) => {
					// Get the total cart price in dollar amount
					var totalPrice = cart.total_price / 100;

					// Show the cart message if the cart total is within the specified bounds
					if (totalPrice >= this.min && totalPrice < this.max) {
						this.cartMessage.show();
					} else {
						this.cartMessage.hide();
					}
				});

				this.button = this.cartMessage.find('.cart-message__button');

				if (this.button && this.button.attr('href') == undefined) {
					// If the button has no link let's make it close the cart popup on click
					this.button.on('click', (e) => {
						e.preventDefault();
						// Trigger a click on the cart close button
						$('.js-close-mfp').trigger('click');
					});
				}
			}
		},
	};

	cartMessage.init();

	$('.collection-description .cta').click(function (e) {
		e.preventDefault();
		if ($(this).hasClass('readmore')) {
			$('.boost-pfs-section-header').addClass('show-full-content');
		} else {
			$('.boost-pfs-section-header').removeClass('show-full-content');
		}

		if ($(this).hasClass('cta_readmore')) {
			$(
				'.boost-pfs-filter-collection-description--full .inner.text-ellipsis'
			).removeClass('text-ellipsis');
		} else {
			$('.boost-pfs-filter-collection-description--full .inner').addClass(
				'text-ellipsis'
			);
		}
	});

	$(document).mouseup(function (e) {
		var container = $('.boost-pfs-filter-tree-content');
		// if the target of the click isn't the container nor a descendant of the container
		if (
			!container.is(e.target) &&
			container.has(e.target).length === 0 &&
			$('.boost-pfs-filter-tree-mobile-open').length > 0
		) {
			$('.boost-pfs-filter-tree-mobile-button button').trigger('click');
		}
	});
	$('.js-cart-trigger').on('click', function (e) {
		e.preventDefault();
		$('html, body').addClass('cart-open');
	});
	$('body').on('click', '.ajaxcart-draw__close', function (e) {
		e.preventDefault();
		$('html, body').removeClass('cart-open');
	});
	$(document).mouseup(function (e) {
		let container = $('.ajaxcart-draw');
		// if the target of the click isn't the container nor a descendant of the container
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('html, body').removeClass('cart-open');
		}
	});

	$('body').on('afterCartLoad.ajaxCart', function () {
		ShopifyAPI.getCart();
		if ($('#sca-fg-owl-carousel').length > 0) {
			$('#sca-fg-owl-carousel').addClass('active');
		}
	});

	/**
	 * Geolocation pop up
	 */
	//
	$.getJSON('https://jsonip.com/?callback=?').done(function (data) {
		var ip_address = window.JSON.parse(JSON.stringify(data, null, 2));
		customerIP = ip_address.ip;
		jQuery.ajax({
			url:
				'https://oxe3q02thl.execute-api.ap-southeast-2.amazonaws.com/?ip=' +
				customerIP,
			dataType: 'json',
			success: function (res) {
				if (res.success) {
					const countryCode = res.data.country_code;
					if (countryCode == 'NZ') {
						$('.modal__overlay--newsletter').addClass('country-code__NZ');
					}
				}
			},
		});
	});

	$('.modal__overlay--newsletter .close').click(function () {
		$('.modal__overlay--newsletter').removeClass('country-code__NZ');
	});

	/**
	 * Drop Down in Footer
	 */

	$('.location').click(function () {
		$(this).toggleClass('active');
		$('.location-list').toggleClass('active');
	});

	/**
	 * Search on mobile
	 */
	$('.header-top .search__form-input').on('input',function(e){
		var _v = $(this).val();
		if(_v != ''){
			$('html').addClass('search-box-visible');
		} else{
			$('html').removeClass('search-box-visible');
		}
	});
});

$(document).on('click touch', function(e) { 
	var dropdown = $(".boost-pfs-search-suggestion");
	if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
		$('html').removeClass('search-box-visible');
	}
});